/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState } from "react"
import forma from '../images/forma-ovale.svg'
import virgolette from '../images/virgolette.svg'
import tabSelected1 from '../images/tab-selected-1.svg'
import tabSelected2 from '../images/tab-selected-2.svg'
import frecciaOrange from '../images/freccia-orange.svg'

const Page8 = ({ backgroundColor, openPercent, color, innerRef }) => {

  const [tabSelected,setTab] = useState(1)

  return (
    <div ref={innerRef} style={{ height: "100%", background: backgroundColor, color: color }} className="h-100 grid-cols-12 xl:grid-cols-12">
      <div className='col-1'>
      </div>
      <div className='col-5'>
        <div className='lg:mt-8 xl:mt-6 lg:font-18 xl:font-16 lg:line-height-24 xl:line-height-22'>
          Un trend, questo, presente da tempo: le vetture elettriche acquistate
          in Italia nel 2018 sono state oltre 2500, contro le 550 dell’anno precedente,
          registrando una crescita del 366 per cento; non è lo stesso per quelle a benzina,
          che in termini di vendite hanno perso nel giro di un anno 15 punti percentuali.
        </div>
        <div className='lg:mt-3 xl:mt-2 lg:font-18 xl:font-16 lg:line-height-24 xl:line-height-22'>
          Più in generale, i vantaggi dei veicoli elettrici maggiormente percepiti dai
          fleet manager sono di natura economica (risparmio di carburante, libero accesso alle ZTL,
          altre agevolazioni nella circolazione o sosta) e reputazionale (responsabilità
          d'impresa alla riduzione delle emissioni inquinanti e climalteranti).
        </div>
        <div className='lg:mt-3 xl:mt-2 lg:font-18 xl:font-16 lg:line-height-24 xl:line-height-22'>
          Rispetto al 2018, si registra inoltre una crescita di 10 punti percentuali –
          dal 46 per cento al 56 per cento – delle imprese che hanno installato <a className='link' target='_blank' rel="noopener noreferrer" href='https://www.efficienzaenergetica.edison.it/offerta/o/servizio-ricarica-veicoli-elettrici-imprese/'>
           soluzioni di ricarica presso la propria sede
          </a>, e di 20 punti percentuali – dal 63 per
          cento all’84 per cento – di quelle che hanno stipulato accordi con le utilities dell’energia.
        </div>
        <div className='lg:mt-3 xl:mt-2 lg:font-18 xl:font-16 lg:line-height-24 xl:line-height-22'>
          L’esperienza di alcuni Paesi virtuosi – come la Norvegia – sulla conversione
          all’elettrico ha dimostrato indubbiamente che quando la politica incentiva
          l’acquisto di veicoli a impatto zero, il consumatore risponde positivamente.
        </div>
      </div>
      <div className='col-1'>

      </div>
      <div className='col-5'>
        <div className='lg:mt-8 xl:mt-6 text-center' style={{ backgroundImage: `url("${forma}")`, height: 443, width: 443 }}>
          <div className='mt-8'><img src={virgolette} alt='Virgolette' width='55' /></div>
          {tabSelected === 1 ?
            <div style={{position: 'relative', minHeight: 288}}>
              <div className='mt-2 font-family-acumin font-weight-500 lg:font-18 xl:font-16 lg:line-height-24'>
                Abbiamo 11 sedi, di cui sette <br /> concentrate nel Nord Italia e una<br /> flotta
                aziendale di circa 130 auto.<br />Fino al 2015 abbiamo avuto una<br /> flotta tradizionale
                a diesel, poi<br /> abbiamo attuato un cambio di<br /> direzione, grazie alla lungimiranza.
              </div>
              <div className='cursor-pointer mt-4' onClick={() => setTab(2)}>
                <img src={tabSelected1} alt='tabSelected1' />
              </div>
              <div className='ml-7 mt-2' style={{position: 'absolute', bottom: 0}}>
                <div style={{ height: 2, backgroundColor: '#FF6B29', width: 45}}></div>
                <div className='font-14 text-left mt-1'>Mario Rondella</div>
                <div className='font-12 text-left'>Alfa Laval – Site Services Manager</div>
              </div>
            </div>
          :
          <div style={{position: 'relative', minHeight: 288}}>
            <div className='mt-2 font-family-acumin font-weight-500 lg:font-18 xl:font-16 lg:line-height-24'>
              L’azienda era cosciente del fatto <br />
              che i pionieri devono sostenere  <br />
              il prezzo dell’innovazione: a volte<br />
              bisogna indicare la strada agli altri,  <br />
              a costo di decisioni impopolari.
            </div>
            <a target='_blank' rel="noopener noreferrer" href={'https://www.ilsole24ore.com/art/dopo-cambio-rotta-meta-flotta-e-ibrida-ACuYjYt'} className='link sole-24-ore mt-3 cursor-pointer font-14 d-flex align-items-center text-center justify-content-center'>
              Il Sole 24 Ore <img style={{ marginLeft: 5 }} src={frecciaOrange} alt='Il sole 24 ore' />
            </a>
            <div className='cursor-pointer mt-4' onClick={() => setTab(1)}>
              <img src={tabSelected2} alt='tabSelected1' />
            </div>
            <div className='ml-7 mt-2' style={{position: 'absolute', bottom: 0}}>
              <div style={{ height: 2, backgroundColor: '#FF6B29', width: 45}}></div>
              <div className='font-14 text-left mt-1'>Mario Rondella</div>
              <div className='font-12 text-left'>Alfa Laval – Site Services Manager</div>
            </div>
          </div>
          }
        </div>
      </div>
    </div>
  )
}

export default Page8
